import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStreamPlatformFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("g", {
			id: "StreamingPlatform",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Platform=facebook 2",
				clipPath: "url(#clip0_4346_6138)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Subtract",
					d: "M16 0C24.8364 0 32 7.16356 32 16C32 24.1793 25.8617 30.9243 17.9395 31.8838V20.8887H22.2656L23.1621 16H17.9326V14.2715C17.9326 11.6857 18.9444 10.6934 21.5684 10.6934C22.3806 10.6934 23.0402 10.7128 23.418 10.751V6.32129C22.7007 6.12308 20.954 5.9258 19.9424 5.92578C14.5984 5.92578 12.1338 8.44733 12.1338 13.8936V16H8.83203V20.8896H12.1338V31.5283C5.16481 29.7989 0 23.5034 0 16C6.44318e-08 7.16356 7.16356 6.44276e-08 16 0Z",
					fill: "currentColor"
				})
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4346_6138",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgStreamPlatformFacebook;
